import React, { useState, useEffect } from 'react'
import { PageHeader, Button, Table, Skeleton, Popconfirm, Modal } from 'antd'
import { useQuery } from '@apollo/react-hooks'
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons'

import ResultError from '@packages/ResultError'
import { EXPERTS_ICON } from '@constants/IconsConstants'
import { useColumnFilterProps } from '@utils/columnFilter'
import { getExpertsQuery } from '@graphql/queries'
import { useUpdateExpert, useDeleteExpert } from '@graphql/mutations'

import EditableCell from '../../EditableCell'
import ManageExpertForm from '../ManageExpertForm'

const tableProps = {
  size: 'middle',
  pagination: false,
}
const newButtonProps = {
  type: 'primary',
  icon: <PlusOutlined />,
  key: 'newExpert',
}

function ManageExpertTable() {
  const [expertsData, setExpertsData] = useState(false)
  const [formModalVisible, setFormModalVisible] = useState(false)
  const { error, data } = useQuery(getExpertsQuery)
  const [updateExpert] = useUpdateExpert()
  const [deleteExpert] = useDeleteExpert()
  const useFilterField = field => useColumnFilterProps(field)
  const toggleFormModal = () => setFormModalVisible(!formModalVisible)

  useEffect(() => {
    if (data) setExpertsData(data.experts)
  }, [data])

  const handleSave = data => {
    const { id, name } = data
    const newData = [...expertsData]
    const index = newData.findIndex(item => item.id === data.id)
    const item = newData[index]

    newData.splice(index, 1, { ...item, ...data })

    if (JSON.stringify(newData) !== JSON.stringify(expertsData)) {
      updateExpert({
        variables: {
          id,
          data: {
            name: { set: name },
          },
        },
      })

      setExpertsData(newData)
    }
  }

  const handleDelete = id => {
    deleteExpert({
      variables: { id },
      refetchQueries: ['GetExpertsQuery'],
    })
  }
  const columns = [
    {
      dataIndex: 'name',
      title: 'Nome',
      editable: true,
      ...useFilterField('name'),
    },
    {
      align: 'center',
      render: (value, { id, name }) => (
        <Popconfirm
          title={`Tem a certeza que quer eliminar ${name} ?`}
          onConfirm={() => handleDelete(id)}
          okText="Sim"
          cancelText="Não"
        >
          <DeleteOutlined />
        </Popconfirm>
      ),
    },
  ]
  const mappedColumns = columns.map(col => {
    if (!col.editable) return col

    return {
      ...col,
      onCell: record => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave,
      }),
    }
  })

  return (
    <>
      <Modal
        title="Novo técnico"
        visible={formModalVisible}
        onCancel={() => toggleFormModal()}
        footer={null}
      >
        <ManageExpertForm afterSubmit={() => toggleFormModal()} />
      </Modal>

      <PageHeader
        title="Técnicos"
        avatar={{ src: EXPERTS_ICON }}
        extra={[
          <Button {...newButtonProps} onClick={() => toggleFormModal()}>
            Novo técnico
          </Button>,
        ]}
      />

      {error && <ResultError />}

      <Skeleton loading={!error && !expertsData} active>
        {expertsData && (
          <Table
            components={EditableCell.Components}
            columns={mappedColumns}
            dataSource={expertsData}
            rowKey={({ id }) => id}
            rowClassName={() => 'editable-row'}
            {...tableProps}
          />
        )}
      </Skeleton>
    </>
  )
}

export default ManageExpertTable
